module.exports = __webpack_public_path__ + "static/img/new_program_06.36643a6b.jpg";